import React from "react";
import { TableHeader } from "./TableHeader";
import { TableRow } from "./TableRow";

export class Table extends React.Component {
  render() {
    /* Expected tableContents
         [header1 , header2, ... , headerN]
         [value1 , value2, ... , valueN ]*/
    const headers = this.props.tableContents[0];
    let rows = [];
    for (let i = 1; i < this.props.tableContents.length; i++) {
      rows.push(<TableRow contents={this.props.tableContents[i]} />);
    }

    return (
      <table style={tableStyle} className="table table-sm mx-4 my-2">
        <thead>
          <TableHeader contents={headers} />
        </thead>
        <tbody>{rows}</tbody>
      </table>
    );
  }
}

const tableStyle = {
  height: 40,
};
